import axios from 'axios'

export function searchHedges (search, params = null) {
  let config = {}
  if (params) config.params = params
  return axios.get('/api/hedges/?search=' + search, config)
}

export function fetchHedgeDistributions (hedgeId) {
  return axios.get('/api/hedge_distributions/', {
    params: {
      page_size: 0,
      hedge: hedgeId
    }
  })
}
